import { render } from "./ChooseTenant.vue?vue&type=template&id=59c4502f&scoped=true&ts=true"
import script from "./ChooseTenant.vue?vue&type=script&lang=ts"
export * from "./ChooseTenant.vue?vue&type=script&lang=ts"

import "./ChooseTenant.vue?vue&type=style&index=0&id=59c4502f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59c4502f"]])

export default __exports__